import { authClient } from "@/lib/auth-client";
import { Outlet } from "react-router";
import { Loader2 } from "lucide-react";

import LandingRedirect from "@/components/common/LandingRedirect";

export default function NoAuthGuard() {
  const { data: session, isPending } = authClient.useSession();

  // console.log(session);

  if (isPending) {
    return (
      <div className="h-screen w-full flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // A dónde va depende del plan, no siempre al dashboard.
  if (session) {
    return <LandingRedirect />;
  }

  return <Outlet />;
}
